
<div class="theme-default">
  <div id="app">
    <div class="app__container">
      <form id="login" class="login__panel" (ngSubmit)="Login()">
        <img src="assets/images/logo-white.svg" class="login__logo mx-auto p-3 mb-1" alt="JobTrain" />
        <div *ngIf="this.authService.error != ''" class="alert alert-warning alert-dismissible fade show" role="alert">
          {{this.authService.error}}
          <button type="submit" class="close" data-dismiss="alert" aria-label="Close">
            <svg viewBox="0 0 12 12">
              <path fill="none" d="M0 0h12v12H0V0z" />
              <path class="icon-fill" d="M9.9 2.9l-.8-.8L6 5.3 2.9 2.1l-.8.8L5.3 6 2.1 9.1l.8.8L6 6.7l3.1 3.2.8-.8L6.7 6z" />
            </svg>
          </button>
        </div>

        <input id="username" [(ngModel)]="user.userName" name="username" type="text" required="required" class="login__input mb-lg" placeholder="Username" />

        <input id="password" [(ngModel)]="user.password" name="password" type="password" required="required" class="login__input mb-md" placeholder="Password" />

        <a href="#" (click)="redirectToUrl()" class="button__link button--small button__link--primary mb-xl">Forgot Password?</a>

        <button type="submit" class="button button--highlight mb-xl mx-auto">
          {{ common.loginButtonText }}
        </button>
          <button *ngIf="ssoConfig !=null && ssoConfig.SingleSignOn == commonEnum.Yes && ssoConfig.SingleSignOn_Type == ssoType.Cas" class="button button--highlight mb-xl mx-auto sso-login" href="#" (click)="CASLogin()">
            NTU Login
          </button>
          <a href="#" (click)="GoToDesktop()" class="button__link button--small button__link--primary mx-auto">Go to the desktop version</a>

      </form>

     


    </div>

  </div>


</div>
